import React from "react";
import { Stack } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";

import WorkOrderTableHeader from "./WorkOrderTableHeader";
import WorkOrderTableBody from "./WorkOrderTableBody";
import WorkOrderTableAddRow from "./WorkOrderTableAddRow";

import {
  handleAddHelper,
  handleBarcodeHelper,
  onBarcodeScanHelper,
} from "./helper";
import { useScannerHelper } from "../../../helpers";
import { useUserHookFormList } from "../../../components/UsersHookFormSelect";

export const WorkOrderTable = ({ disabled, options = [] }) => {
  const fieldArrayOptions = useFieldArray({
    name: "workOrders",
    shouldUnregister: true,
    rules: {
      required: "At least 1 Work Order is required",
    },
  });
  const { append, remove, fields } = fieldArrayOptions;
  const { getValues, setValue } = useFormContext();
  const { users } = useUserHookFormList();

  const handleWorkOrderAdd = (defaultValues) =>
    handleAddHelper({
      defaultValues,
      append,
      getValues,
      setValue,
      options,
    });

  const handleBarcodeScan = ({ workOrderId, barcode }) =>
    handleBarcodeHelper({
      workOrderId,
      barcode,
      append,
      getValues,
      setValue,
      options,
    });

  const onScan = (barcode = "") =>
    onBarcodeScanHelper({
      barcode,
      options,
      addworkOrder: handleBarcodeScan,
      setValue,
      users,
    });

  useScannerHelper(onScan, [], true);

  return (
    <Stack width="100%" overflow="hidden">
      <WorkOrderTableHeader />
      <WorkOrderTableBody {...{ disabled, options, remove, fields }} />
      <WorkOrderTableAddRow {...{ disabled, options, handleWorkOrderAdd }} />
    </Stack>
  );
};

export default WorkOrderTable;
